import { tryParseJson } from "./stringUtilities";
export function getClientSettings() {
    const sharedWidgetInfoElement = document.querySelector(".peregrine-widget-settings");
    const settingsString = sharedWidgetInfoElement && sharedWidgetInfoElement.getAttribute("data-client-settings");
    let clientSettings = undefined;
    if (settingsString) {
        clientSettings = tryParseJson(settingsString) || undefined;
    }
    return clientSettings;
}
